import React from 'react';
import { Button, DialogV2 } from 'c-components';
import { PermissionName } from 'c-sdk';
import { IfHasAllPermissions } from 'c-auth-module/Components';
import { useCommonTranslation } from 'c-translation';
import { MassUpdatingDisplays } from 'c-displays/Pages/utils';

const massUpdatePerms = [PermissionName.AdminDisplaysMass_update];

interface MassAllocationDialogProps {
    dialogState: {
        value: boolean;
        setFalse: () => void;
        setTrue: () => void;
    };
}

const MassAllocationDialog: React.FC<MassAllocationDialogProps> = ({ dialogState }) => {
    const t = useCommonTranslation();

    return (
        <IfHasAllPermissions permissions={massUpdatePerms}>
            <DialogV2
                onClose={() => dialogState.setFalse()}
                open={dialogState.value}
                title="Modules.Displays.DisplaysList.massUpdating"
            >
                <MassUpdatingDisplays location="Displays_Screen" dialogState={dialogState} />
            </DialogV2>
            <Button
                size="small"
                sx={{
                    minHeight: 26,
                    minWidth: 0,
                    px: 1,
                    py: 0.3,
                    fontSize: '0.72rem',
                    lineHeight: 1.1,
                }}
                onClick={() => dialogState.setTrue()}
            >
                {t('Modules.Displays.DisplaysList.massUpdating')}
            </Button>
        </IfHasAllPermissions>
    );
};

export default MassAllocationDialog;
